import { Component, OnDestroy } from '@angular/core';
import { ActionSheetController, NavController, AlertController, ToastController, ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { CustomerRegistrationPage } from '../customerRegistration/customerRegistration';
import { CustomerEditPage } from '../customerEdit/customerEdit';
import { AddressesPage } from '../addresses/addresses';
import { CustomerCardPage } from '../customercard/customercard';
import { AboutPage } from '../../about/about';
import { MenuPage } from '../../menu/menu';
import { CustomizerProvider } from '../../../providers/customizer/customizer';


@Component({
  selector: 'page-customer',
  templateUrl: 'customer.html'
})
export class CustomerPage implements OnDestroy {
  restaurant: any;
  login = { username: '', password: '' };
  customerInfo = {};
  url: string;
  GOTOedit = CustomerEditPage;
  GOTOaddresses = AddressesPage;
  GOTOregistration = CustomerRegistrationPage;
  GOTOcards = CustomerCardPage;
  GOTOinfoLocale = AboutPage;
  private _onDestroy = new Subject();

  constructor(public navCtrl: NavController,
    public translateService: TranslateService,
    public storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public provider: provider,
    public actionSheetCtrl: ActionSheetController,
    public viewCtrl: ViewController,
    public customizer: CustomizerProvider,
    public http: HttpClient) {

    this.url = provider.getUrl();

    storage.get('customer').then((customer) => {
      this.customerInfo = JSON.parse(customer);
    });

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  GOTOchangePsw() {
    // this.translateService.get('E9999').takeUntil(this._onDestroy).subscribe(value => { errore = value });

    let prompt = this.alertCtrl.create({
      title: 'Hai dimenticato la password?',
      message: "Scrivi la mail inserita durante la registrazione e clicca su invia per ricevere una nuova password",
      inputs: [{
        name: 'email',
        placeholder: 'email@dominio.it',
        type: 'email'
      }],
      buttons: [
        { text: 'Annulla' },
        {
          text: 'Invia email',
          handler: data => {
            this.provider.recoverPassword(data.email).takeUntil(this._onDestroy).subscribe(data => {
              let toast = this.toastCtrl.create({
                message: 'Email inviata! Controlla la tua casella',
                duration: 5000,
                position: 'middle'
              });
              toast.present();
            }, err => {
              let toast = this.toastCtrl.create({
                message: err._body,
                duration: 3000,
                position: 'middle'
              });
              toast.present();
            });
          }
        }
      ]
    });
    prompt.present();
  }

  access() {
    this.provider.login(this.login).takeUntil(this._onDestroy).subscribe(data => {
      // ricevi dal server il cliente e mostra il prompt personalizzato
      const customer = JSON.parse((<any>data)._body);
      this.storage.set('customer', (<any>data)._body).then(() => {
        let toast = this.toastCtrl.create({
          message: 'Ciao ' + customer.firstName + ' !!!',
          duration: 3000,
          position: 'middle'
        });
        toast.present().then (() => {
          this.navCtrl.push(MenuPage);
        });
      });
    }, err => {
      console.log(err);
      let msg;
      if(err._body == "Login or Password are wrong") {
        this.translateService.get('WRONG_LOGIN').takeUntil(this._onDestroy).subscribe(value => { 
          let toast = this.toastCtrl.create({
            message: value,
            duration: 3000,
            position: 'middle'
          });  
          toast.present();
        });
      }
      else {
        let toast = this.toastCtrl.create({
          message: err._body,
          duration: 3000,
          position: 'middle'
        }); 
        toast.present();
      }
      
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/customer/customer.ts